module.exports = __webpack_public_path__ + "static/img/enroll.ddee2444.png";